var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general-wrapper"},[_c('Header',{attrs:{"parent":"stickers_gallery"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$t("tables.orders_history"))+"\n    ")]},proxy:true}])}),_c('IQOSTable',{attrs:{"rows":_vm.shipments,"cols":[
      {
        title: _vm.$t('subscription.transactions.date'),
        key: 'created_at',
        date: true,
      },
      {
        title: _vm.$t('subscription.transactions.time'),
        key: 'created_at',
        time: true,
      },
      {
        title: _vm.$t('shipments_table.recipient'),
        key: 'recipient',
      },
      {
        title: _vm.$t('shipments_table.delivery'),
        key: 'delivery',
        renderer: function (r) { return r.warehouse || r.address; },
      },
      {
        title: _vm.$t('shipments_table.contents'),
        key: 'contents',
      },
      {
        title: _vm.$t('subscription.transactions.sum'),
        key: 'total',
        unit: 'UAH',
      },
      {
        title: _vm.$t('subscription.transactions.status'),
        key: 'status',
      } ]},scopedSlots:_vm._u([{key:"col-contents",fn:function(slotProps){return _vm._l((slotProps.rowItem.contents),function(content,index){return _c('div',{key:index},[_vm._v("\n        "+_vm._s(_vm.capitalize(content.template))+" ("+_vm._s(content.system.toUpperCase())+") x"+_vm._s(content.count)+"\n      ")])})}},{key:"col-status",fn:function(slotProps){return [(slotProps.rowItem.status == 'shipped')?_c('span',{staticClass:"green-5-color"},[_vm._v("\n        "+_vm._s(_vm.$t("shipments_table.statuses.shipped"))+"\n      ")]):_vm._e(),(slotProps.rowItem.status == 'returned')?_c('span',{staticClass:"red-4-color"},[_vm._v("\n        "+_vm._s(_vm.$t("shipments_table.statuses.returned"))+"\n      ")]):_vm._e(),(slotProps.rowItem.status == 'shipping')?_c('span',{staticClass:"v1-grey-10-color"},[_vm._v("\n        "+_vm._s(_vm.$t("shipments_table.statuses.shipping"))+"\n      ")]):_vm._e(),(
          slotProps.rowItem.status == 'preparing' ||
          slotProps.rowItem.status == 'printing'
        )?_c('span',{staticClass:"orange-4-color"},[_vm._v("\n        "+_vm._s(_vm.$t("shipments_table.statuses.preparing"))+"\n      ")]):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }